import { render } from "./update.vue?vue&type=template&id=21d25300&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import "./update.vue?vue&type=style&index=0&id=21d25300&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d25300"]])

export default __exports__